// 实时爆料流数据 —— 静态展示数据

export const liveFilterTabs = [
  { key: "all", label: "全部" },
  { key: "明星动态", label: "明星" },
  { key: "影视综艺", label: "影视" },
  { key: "网络热梗", label: "网络" },
  { key: "体坛风云", label: "体坛" },
  { key: "电竞游戏", label: "电竞" },
  { key: "社会民生", label: "社会" },
];

export const liveFeedItems = [
  { time: "刚刚", cat: "影视综艺", title: "《星夜盲盒》节目组再发声明，就赛果争议补充说明", tag: "新", heat: "高" },
  { time: "3分钟前", cat: "明星动态", title: "顶流歌手官宣巡演首站，开票平台一度被挤崩", tag: "爆", heat: "高" },
  { time: "7分钟前", cat: "网络热梗", title: "\u201c已老实求放过\u201d冲上神评，出处竟是一场直播事故", tag: "热", heat: "中" },
  { time: "12分钟前", cat: "电竞游戏", title: "冠军中单现身后台视频流出，全程未提转会传闻", tag: "热", heat: "中" },
  { time: "18分钟前", cat: "影视综艺", title: "《长夜将明》导演直播答疑，回应第二季拍摄计划", tag: "新", heat: "中" },
  { time: "25分钟前", cat: "社会民生", title: "夜经济观察报道引共鸣，评论区集体\u201c破防\u201d", tag: "热", heat: "中" },
  { time: "31分钟前", cat: "音乐现场", title: "年度音乐节X位嘉宾线索再+1，主办方故弄玄虚", tag: "新", heat: "中" },
  { time: "40分钟前", cat: "体坛风云", title: "女足逆转功臣深夜发博：拼到最后一秒才值", tag: "热", heat: "中" },
  { time: "46分钟前", cat: "明星动态", title: "新生代演员新剧官宣阵容，搭档组合引发期待", tag: "新", heat: "中" },
  { time: "53分钟前", cat: "科技数码", title: "折叠屏新机首销战报出炉，铰链成最大卖点", tag: "新", heat: "低" },
  { time: "1小时前", cat: "网络热梗", title: "主播深夜开播回应节奏，承诺后续只发正式声明", tag: "爆", heat: "高" },
  { time: "1小时前", cat: "影视综艺", title: "老牌IP宣布重启，原班人马是否回归成谜", tag: "新", heat: "中" },
  { time: "1小时前", cat: "社会民生", title: "城市夜跑团走红网络，主打治愈都市压力", tag: "新", heat: "低" },
  { time: "1小时前", cat: "电竞游戏", title: "新赛季版本全面更新，多家战队公布首发展望", tag: "新", heat: "低" },
];